<template>
  <v-card class="ma-5">
    <v-card-text>
    </v-card-text>
  </v-card>
</template>

<script setup>


</script>
